var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"28","height":"28","fill":"#974900","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M11.172 12l-.708.707L14 16.243l3.535-3.536-.707-.707L14 14.828 11.172 12z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }